"use client";
import { twMerge } from "tailwind-merge";
import { ControlBase } from "./primitives/ControlBase";
import { ControlButton } from "./primitives/ControlButton";
import type { ControlPosition } from "./primitives/utils";

/**
 * List toggle control for switching to a list view of map data
 *
 * **Note:** This control is automatically hidden on desktop (≥768px) as it's
 * primarily useful for mobile devices where a list view provides better UX.
 */
interface MapListControlProps {
  position?: ControlPosition;
  className?: string;
  /**
   * Custom positioning - overrides position prop
   * Example: { top: '20px', right: '20px' }
   */
  style?: React.CSSProperties;
  /**
   * Callback when list toggle button is clicked
   */
  onToggle?: () => void;
  /**
   * Whether the list view is currently active (for visual feedback)
   * @default false
   */
  isActive?: boolean;
}

export function ListControl({
  position = "top-right",
  className,
  style,
  onToggle,
  isActive = false,
}: MapListControlProps) {
  return (
    <ControlBase position={position} className={twMerge("md:hidden", className)} style={style}>
      <ControlButton
        icon="ListDashes"
        onPress={onToggle}
        isActive={isActive}
        ariaLabel={isActive ? "Hide list view" : "Show list view"}
      />
    </ControlBase>
  );
}
